// directive: {
//   letters: 1, 小写转大写，不能输入中文
//   zero: 1 去掉前面多余的0
//   precision: 2, 保留几位小数
//   min: 5
//   max: 9
// }, 

export default {
  bind(el, vDir,vNode) {
    let content
    const regCN = /[^\x00-\xff]/g //中文和中文字符
    var re = /^-?([1-9]\d*(\.{1,2})?|0\.\d{1,2})$/g //去掉数字前面的多余的0
    // letters是否大小写 1-大写
    el.oninput = (event) => {


      event.target.value = event.target.value.replace(regCN, "")

      //数字去掉多余的0
      if (vDir.value && vDir.value.zero === 1) {
        event.target.value = event.target.value.replace(re, "")

      }

    }
    el.addEventListener("input",event=>{

      if(vDir.value&&vDir.value.letters === 1){
        const setVal = val => {
          if (vNode.componentInstance) {
            // 如果是自定义组件就触发自定义组件的input事件
            vNode.componentInstance.$emit("input", val);
          } else {
            // 如果是原生组件就触发原生组件的input事件
            el.value = val;
            el.dispatchEvent(new Event("input"));
          }
        };

        setVal(event.target.value.toUpperCase())
      }
    })

    if(vDir.value&&(vDir.value.precision||vDir.value.min||vDir.value.max)){
      // 保留指定位小数
      const toFixedPlus = (num, decimal) => {
        num = num.toString();
        let index = num.indexOf(".");
        let isFixed = vDir?.value?.isFixed
        let precision = vDir?.value?.precision
        let isE = num.indexOf("e+");
        if (index !== -1 && isE === -1) {
          if (decimal === 0) {
            num = num.substring(0, index);
          } else {
            num = num.substring(0, decimal + index + 1);
            if (isFixed) {
              let length = num.substring(index + 1)
              if (isFixed === 1 && length.length < precision) {
                for (let i = 0; i < precision - length.length; i++) {
                  num = num + '0'
                }
              }
              if (isFixed > 1 && length.length < isFixed) {
                for (let i = 0; i < isFixed - length.length; i++) {
                  num = num + '0'
                }
              }
            }
          }
        } else {
          if (isFixed === 1) {
            num = num.substring(0) + '.00'
          } else {
            num = num.substring(0);
          }
        }
        return num;
      };
      // 设置输入框的值,触发input事件,改变v-model绑定的值
      const setVal = val => {
        if (vNode.componentInstance) {
          // 如果是自定义组件就触发自定义组件的input事件
          vNode.componentInstance.$emit("input", val);
        } else {
          // 如果是原生组件就触发原生组件的input事件
          el.value = val;
          el.dispatchEvent(new Event("input"));
        }
      };
      // 格式化数值
      const formatNum = value => {
        let valueCopy = JSON.parse(JSON.stringify(value));
        let length = vDir?.value?.length;
        let index = value.toString().indexOf(".");
        if (length) {
          let number = "";
          if (index !== -1) {
            let arr = value.split(".");
            number = arr[0].substr(0, length) + "." + arr[1];
          } else {
            number = value.substr(0, length);
          }
          value = number;
        }
        value = parseFloat(value);
        let isE = value.toString();
        if (isE.includes("e+")) {
          value = valueCopy;
        }
        return value;
      };
      // 失去焦点=>保留指定位小数
      el.addEventListener("focusout", event => {
        // 此处会在 el-input 的 @change 后执行
        const e = event || window.event;

        content = formatNum(e.target.value);
        if (isNaN(content)) {
          setVal("");
          return;
        }
        let value = vDir?.value;
        if (!content && content !== 0) {
          content = "";
        }
        let arg_precision = 2; // 默认保留2位小数
        if (value?.precision || value?.precision === 0) {
          arg_precision = parseFloat(vDir.value.precision);
        }

        e.target.value = toFixedPlus(content, arg_precision);

        setVal(e.target.value);


        let arg_max = "";
        let arg_min = "";
        // let value = vDir?.value;
        if (!content && content !== 0) {
          content = "";
        }

        if (value?.max) {
          arg_max = parseFloat(vDir.value.max);
        }
        if (value?.min || value?.min === 0) {
          arg_min = parseFloat(vDir.value.min);
        }
        if (arg_max && content > arg_max) {
          setVal(arg_max);
          content = arg_max;
        }
        if ((arg_min || arg_min === 0) && content < arg_min) {
          setVal(arg_min);
          content = arg_min;
        }
      });
    }


  },
}
